class KikFaqAccordion extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('.section-kik-faq-accordion__trigger').forEach((trigger) => {
      trigger.addEventListener('click', () => this._toggle(trigger));
    });

    const seeAll = this.parentElement && this.parentElement.querySelector('.js-faq-see-all');
    if (seeAll) {
      seeAll.addEventListener('click', () => this._showAll(seeAll));
    }
  }

  _toggle(trigger) {
    const item = trigger.closest('.section-kik-faq-accordion__item');
    const isOpen = item.classList.contains('is-open');

    this.querySelectorAll('.section-kik-faq-accordion__item.is-open').forEach((openItem) => {
      openItem.classList.remove('is-open');
      openItem.querySelector('.section-kik-faq-accordion__trigger').setAttribute('aria-expanded', 'false');
    });

    if (!isOpen) {
      item.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
    }
  }

  _showAll(btn) {
    this.querySelectorAll('.section-kik-faq-accordion__item--overflow').forEach((item) => {
      item.classList.remove('section-kik-faq-accordion__item--overflow');
    });

    const cta = btn.closest('.section-kik-faq-accordion__cta');
    if (cta) cta.style.display = 'none';
  }
}

if (!customElements.get('kik-faq-accordion')) {
  customElements.define('kik-faq-accordion', KikFaqAccordion);
}
